<template>
  <div>
    <b-modal
      id="map-modal"
      ref="map-modal-ref"
      hide-footer
      title="Map"
      style="border: 1px solid red; margin-top: 150px; position: absolute; top: 80px"
    >
      <Map ref="map-ref" />
    </b-modal>
  </div>
</template>

<script>
import Map from './map';

export default {
  components: {
    Map
  },
  methods: {
    show(mapData) {
      this.$refs['map-modal-ref'].show()
      setTimeout(() => {
        this.$refs['map-ref'].initializeMap(mapData)
      })
    },
  }
};
</script>

<style>
@import './styles.scss';
</style>
